"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiagramGameplayContainer2 = void 0;
const react_1 = __importStar(require("react"));
const gameplay_components_1 = require("../../gameplay_components");
const useHowl_1 = __importStar(require("../../hooks/useHowl"));
const asset_key_generator_1 = require("../../asset_key_generator");
const types_1 = require("../types");
const material_1 = require("@mui/material");
const useUserChoices_1 = __importDefault(require("../../hooks/useUserChoices"));
const utils_1 = require("../../utils");
function DiagramGameplayContainer2({ props }) {
    const { initiate, state, play, stop, error, reset: resetHowl, } = (0, useHowl_1.default)({
        onEnd() {
            handleAudioEnd();
        },
    });
    const { userChoices, isFulfilled, addChoice, resetUserChoices } = (0, useUserChoices_1.default)(props.gameplayControl, props.card.cardAnswer.answerTexts, 'FULL_TEXT');
    // hooks
    (0, react_1.useEffect)(() => {
        if (state === useHowl_1.UseHowlState.hasLoaded) {
            play();
        }
    }, [state]);
    (0, react_1.useEffect)(() => {
        if (error) {
            resetUserChoices();
            resetHowl();
            if (props.onFinishCard) {
                props.onFinishCard(props.card);
            }
        }
    }, [error, props.onFinishCard, props.card]);
    (0, react_1.useEffect)(() => {
        switch (props.gameplayControl) {
            case types_1.GameplayControl.PresentQuestion:
                if (props.onPresentQuestion) {
                    props.onPresentQuestion(props.card);
                }
                break;
            case types_1.GameplayControl.Pending:
                break;
            case types_1.GameplayControl.PresentAnswerWithCorrectResponse:
            case types_1.GameplayControl.PresentAnswerWithIncorrectResponse:
                if (props.onPresentAnswer) {
                    props.onPresentAnswer(props.card);
                }
                break;
        }
    }, [
        props.gameplayControl,
        props.onPresentQuestion,
        props.onPresentAnswer,
        props.card,
    ]);
    (0, react_1.useEffect)(() => {
        switch (props.gameplayControl) {
            case types_1.GameplayControl.PresentQuestion:
                if (props.card.cardQuestion.questionAudios.length > 0) {
                    const urls = [];
                    for (const audio of props.card.cardQuestion.questionAudios) {
                        const audioKey = asset_key_generator_1.AssetKeyGenerator.key(audio, asset_key_generator_1.AssetType.Audio);
                        if (props.fileUrls.has(audioKey)) {
                            const url = props.fileUrls.get(audioKey);
                            urls.push(url);
                        }
                    }
                    initiate(urls);
                }
                break;
            case types_1.GameplayControl.Pending:
                stop();
                break;
            case types_1.GameplayControl.PresentAnswerWithCorrectResponse:
                {
                    stop();
                    const urls = [];
                    for (const audio of props.card.cardQuestion.postAnswerAudios) {
                        const audioKey = asset_key_generator_1.AssetKeyGenerator.key(audio, asset_key_generator_1.AssetType.Audio);
                        if (props.fileUrls.has(audioKey)) {
                            const url = props.fileUrls.get(audioKey);
                            urls.push(url);
                        }
                    }
                    if (props.card.gameplayInfo.alwaysPlayPostAnswerAudios &&
                        props.card.cardQuestion.postAnswerAudios.length > 0 &&
                        urls.length === props.card.cardQuestion.postAnswerAudios.length) {
                        initiate(urls);
                    }
                    else {
                        setTimeout(() => {
                            resetUserChoices();
                            resetHowl();
                            if (props.onFinishCard) {
                                props.onFinishCard(props.card);
                            }
                        }, props.rightAnswerDisplayTime * 1000);
                    }
                }
                break;
            case types_1.GameplayControl.PresentAnswerWithIncorrectResponse:
                {
                    stop();
                    const urls = [];
                    for (const audio of props.card.cardQuestion.postAnswerAudios) {
                        const audioKey = asset_key_generator_1.AssetKeyGenerator.key(audio, asset_key_generator_1.AssetType.Audio);
                        if (props.fileUrls.has(audioKey)) {
                            const url = props.fileUrls.get(audioKey);
                            urls.push(url);
                        }
                    }
                    if (props.card.cardQuestion.postAnswerAudios.length > 0 &&
                        urls.length === props.card.cardQuestion.postAnswerAudios.length) {
                        initiate(urls);
                    }
                    else {
                        setTimeout(() => {
                            resetUserChoices();
                            resetHowl();
                            if (props.onFinishCard) {
                                props.onFinishCard(props.card);
                            }
                        }, props.wrongAnswerDisplayTime * 1000);
                    }
                }
                break;
            default:
                break;
        }
    }, [
        props.gameplayControl,
        props.card,
        props.fileUrls,
        props.card.cardQuestion.questionAudios,
        props.card.gameplayInfo.alwaysPlayPostAnswerAudios,
        props.card.cardQuestion.postAnswerAudios,
        props.rightAnswerDisplayTime,
        props.wrongAnswerDisplayTime,
    ]);
    const handleAudioEnd = (0, react_1.useCallback)(async () => {
        if (props.gameplayControl === types_1.GameplayControl.PresentAnswerWithCorrectResponse) {
            await new Promise(res => setTimeout(res, props.rightAnswerDisplayTime * 1000));
            resetUserChoices();
            resetHowl();
            if (props.onFinishCard) {
                props.onFinishCard(props.card);
            }
        }
        else if (props.gameplayControl ===
            types_1.GameplayControl.PresentAnswerWithIncorrectResponse) {
            await new Promise(res => setTimeout(res, props.wrongAnswerDisplayTime * 1000));
            resetUserChoices();
            resetHowl();
            if (props.onFinishCard) {
                props.onFinishCard(props.card);
            }
        }
    }, [props.gameplayControl]);
    // decide if user fulfill the required selection count
    (0, react_1.useEffect)(() => {
        if (props.gameplayControl === types_1.GameplayControl.PresentQuestion &&
            isFulfilled) {
            if (props.onAnswerQuestion) {
                props.onAnswerQuestion(userChoices, props.card);
            }
        }
    }, [isFulfilled]);
    function getQuestionComponent() {
        return (react_1.default.createElement("div", { className: "h-[120px] flex items-center justify-center gap-[8px]" },
            react_1.default.createElement(material_1.Typography, { variant: "h5", onClick: () => {
                    if (props.gameplayControl !== types_1.GameplayControl.PresentQuestion) {
                        return;
                    }
                    stop();
                    play();
                }, color: props.gameplayStyle === types_1.GameplayStyle.PopStudy ? 'black' : 'white', align: "center" }, props.card.cardQuestion.questionText),
            react_1.default.createElement(material_1.Typography, { variant: "body1", color: props.gameplayStyle === types_1.GameplayStyle.PopStudy
                    ? '#000000A3'
                    : '#FFFFFFA3', align: "center" }, [
                types_1.GameplayControl.PresentAnswerWithCorrectResponse,
                types_1.GameplayControl.PresentAnswerWithIncorrectResponse,
            ].includes(props.gameplayControl)
                ? props.card.cardQuestion.translation
                : '')));
    }
    function getChoiceComponent() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return (react_1.default.createElement("div", { className: "bg-white h-[33.75rem] sm:h-[31.5rem] rounded-t-[16px]" },
            react_1.default.createElement(gameplay_components_1.DiagramComponent2, { src: (_c = props.fileUrls.get(asset_key_generator_1.AssetKeyGenerator.key((_b = (_a = props.card.diagram) === null || _a === void 0 ? void 0 : _a.fileName) !== null && _b !== void 0 ? _b : '', asset_key_generator_1.AssetType.Diagram))) !== null && _c !== void 0 ? _c : '', fileName: (_e = (_d = props.card.diagram) === null || _d === void 0 ? void 0 : _d.fileName) !== null && _e !== void 0 ? _e : '', title: (_g = (_f = props.card.diagram) === null || _f === void 0 ? void 0 : _f.title) !== null && _g !== void 0 ? _g : '', targetDetectionId: props.card.cardAnswer.answerTexts[0], highlightIds: props.gameplayControl === types_1.GameplayControl.PresentQuestion
                    ? []
                    : props.gameplayControl === types_1.GameplayControl.Pending
                        ? props.selectedChoices
                        : props.card.cardAnswer.answerTexts, hideForegroundDrawing: props.card.gameplayInfo.name === types_1.Gameplay.DiagramGameplay001
                    ? false
                    : true, 
                // zoomInScale={props.card.diagram?.zoomInScale ?? 0}
                zoomInScale: 1, onSelect: identifier => {
                    if (props.gameplayControl !== types_1.GameplayControl.PresentQuestion) {
                        return;
                    }
                    if (identifier) {
                        addChoice(identifier);
                    }
                }, gameplayStyle: props.gameplayStyle, offsetX: ((_h = props.card.diagram) === null || _h === void 0 ? void 0 : _h.zoomInScale) === 1 ? 0 : 0, offsetY: ((_j = props.card.diagram) === null || _j === void 0 ? void 0 : _j.zoomInScale) === 1 ? 0 : 0 })));
    }
    return (react_1.default.createElement(material_1.ThemeProvider, { theme: (0, utils_1.getTheme)(props.gameplayStyle) },
        react_1.default.createElement("div", { className: "w-full" },
            getQuestionComponent(),
            getChoiceComponent())));
}
exports.DiagramGameplayContainer2 = DiagramGameplayContainer2;
